import type { RealtimeEvent, RealtimeEventHandler, RealtimeEventType } from './types'

export class EventBus {
  private listeners: Map<RealtimeEventType | '*', Set<RealtimeEventHandler>> = new Map()

  on(eventType: RealtimeEventType | '*', handler: RealtimeEventHandler): void {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, new Set())
    }
    this.listeners.get(eventType)!.add(handler)
  }

  off(eventType: RealtimeEventType | '*', handler: RealtimeEventHandler): void {
    this.listeners.get(eventType)?.delete(handler)
  }

  emit(event: RealtimeEvent): void {
    // Emit to specific event type listeners
    this.listeners.get(event.type)?.forEach((handler) => {
      try {
        handler(event)
      } catch (error) {
        console.error(`Error in event handler for ${event.type}:`, error)
      }
    })

    // Emit to wildcard listeners
    this.listeners.get('*')?.forEach((handler) => {
      try {
        handler(event)
      } catch (error) {
        console.error('Error in wildcard event handler:', error)
      }
    })
  }

  removeAllListeners(eventType?: RealtimeEventType | '*'): void {
    if (eventType) {
      this.listeners.delete(eventType)
    } else {
      this.listeners.clear()
    }
  }

  listenerCount(eventType: RealtimeEventType | '*'): number {
    return this.listeners.get(eventType)?.size ?? 0
  }
}
